<h1 class="widget-title">{{ title() }}</h1>

<div class="widget-actions">
  <ng-content select="[widget-actions]"></ng-content>
</div>

@if (canUpload()) {
  <div
    class="upload-dropzone"
    [class.dragging]="isDragging"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)">
    <mat-icon>cloud_upload</mat-icon>
    <span>Drag and drop files here or</span>
    <button mat-stroked-button color="primary" (click)="fileInput.click()" [disabled]="isProcessing()">
      Browse Files
    </button>
    <input
      #fileInput
      type="file"
      multiple
      hidden
      (change)="onFileSelect($event)" />
  </div>
}

@if (isLoading()) {
  <xui-loading-spinner></xui-loading-spinner>
}

<div class="uploads-table-container">
  <table mat-table [dataSource]="sortedUploads()" class="w-100">
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let upload">
        @if (editingUploadId === upload.id) {
          <mat-form-field appearance="fill" class="compact" subscriptSizing="dynamic">
            <input matInput [(ngModel)]="editFileName" />
          </mat-form-field>
        } @else {
          <div class="file-name-cell">
            <xui-file-icon class="file-icon" [extension]="upload.extension" size="small"></xui-file-icon>
            <span class="file-name">{{ upload.fileName }}</span>
            @if (isReferred(upload)) {
              <span class="referral-badge" [title]="getReferralText(upload)">
                <mat-icon>send</mat-icon>
              </span>
            }
          </div>
        }
      </td>
    </ng-container>

    <!-- Date Column -->
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef class="d-responsive d-md">Document Date</th>
      <td mat-cell *matCellDef="let upload" class="d-responsive d-md">
        {{ upload.documentDate | date:'yyyy-MM-dd' }}
      </td>
    </ng-container>

    <!-- Size Column -->
    <ng-container matColumnDef="size">
      <th mat-header-cell *matHeaderCellDef class="d-responsive d-md">Size</th>
      <td mat-cell *matCellDef="let upload" class="d-responsive d-md">
        {{ formatFileSize(upload.size) }}
      </td>
    </ng-container>

    <!-- Tags Column -->
    <ng-container matColumnDef="tags">
      <th mat-header-cell *matHeaderCellDef class="d-responsive d-lg">Tags</th>
      <td mat-cell *matCellDef="let upload" class="d-responsive d-lg">
        <mat-chip-listbox aria-label="tags">
          @for (tag of upload.tags; track tag.tag) {
            <mat-chip-option class="mat-tag" [style.backgroundColor]="tag.hexColor">
              {{ tag.tag }}
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let upload">
        @if (editingUploadId === upload.id) {
          <button mat-icon-button (click)="saveEdit(upload)" [disabled]="isProcessing()">
            <mat-icon>check</mat-icon>
          </button>
          <button mat-icon-button (click)="cancelEdit()">
            <mat-icon>close</mat-icon>
          </button>
        } @else {
          @if (canEdit()) {
            <button mat-icon-button (click)="startEdit(upload)" [disabled]="isProcessing() || upload.processing">
              <mat-icon>edit</mat-icon>
            </button>
          }
          @if (canDelete()) {
            <button mat-icon-button (click)="onDelete(upload)" [disabled]="isProcessing() || upload.processing">
              <mat-icon>delete</mat-icon>
            </button>
          }
          <button mat-icon-button (click)="onDownload(upload)" [disabled]="upload.processing">
            <mat-icon>open_in_new</mat-icon>
          </button>
          @if (upload.processing) {
            <mat-spinner diameter="24"></mat-spinner>
          }
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['name', 'date', 'size', 'tags', 'actions']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['name', 'date', 'size', 'tags', 'actions']" [class.processing]="row.processing"></tr>

    <!-- No Data Row -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell no-data-cell" colspan="5">
        No files have been uploaded for this patient.
      </td>
    </tr>
  </table>
</div>
